import React, { Children } from 'react';
import Button from '@99designs/frontend-components/components/Button/Button';
import Box from '../../Box';
import Card from '../../Card';
import Paragraph from '../../Paragraph';

interface Props {
    children: React.ReactNode;
}

interface CompletedContestCardProps {
    ctaUrl: string;
    ctaLabel: string;
    title: string;
}

function PlaceholderCard({ children }: Props) {
    return <Card variations={['placeholder-card']}>{children}</Card>;
}

export function CompletedContestCardPlaceholderCard({
    ctaUrl,
    ctaLabel,
    title,
}: CompletedContestCardProps) {
    return (
        <Card variations={['placeholder-card']}>
            <Box
                paddingTop="space10"
                paddingRight="space10"
                paddingBottom="space10"
                paddingLeft="space10"
            >
                <Paragraph>{title}</Paragraph>
                <Button href={ctaUrl} variations={['primary', 'jumbo']}>
                    {ctaLabel}
                </Button>
            </Box>
        </Card>
    );
}

export default PlaceholderCard;
